import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
// import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    cart: Cart;
    editable?: boolean;
    onCommentChange?: (updatedComment: string) => void;
    label?: string;
    extendedStyles?: CartCommentStyles;
}

type Props = OwnProps & HasCartLineContext;

export interface CartCommentStyles {
    wrapper?: InjectableCss;
    toggleLink?: LinkPresentationProps;
    editableNotesTextArea?: TextAreaProps;
    readOnlyCommentText?: SmallHeadingAndTextStyles;
}

export const CartCommentStyles: CartCommentStyles = {
    wrapper: {
        css: css`
            width: 100%;
        `,
    },
    toggleLink: {
        css: css`
            margin-bottom: 10px;
        `,
    },
};

const CartLineComment: FC<Props> = ({
    cart,
    cartLine,
    editable = false,
    onCommentChange = () => {},
    label,
    extendedStyles,
}) => {
    const [showComment, setshowComment] = useState(true);
    const lineCommentClickHandler = () => {
        setshowComment(!showComment);
    };

    const [ProductComment, setProductComment] = useState(cartLine.properties.comment);

    const changeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setProductComment(event.currentTarget.value);
    };

    const blurHandler = () => {
        onCommentChange(ProductComment);
    };

    useEffect(() => {
        setProductComment(cartLine.properties.comment);
    }, [cartLine.properties.comment]);

    const heading = showComment ? "Comment" : "Comment";

    const [styles] = React.useState(() => mergeToNew(CartCommentStyles, extendedStyles));

    if (editable) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Link {...styles.toggleLink} data-test-selector="cartCommentShowHideButton">
                    {translate(heading)}
                </Link>
                {showComment && (
                    <TextArea
                        {...styles.editableNotesTextArea}
                        value={ProductComment}
                        disabled={!cart.canModifyOrder}
                        onChange={changeHandler}
                        onBlur={blurHandler}
                        data-test-selector="cartcomment"
                    />
                )}
            </StyledWrapper>
        );
    }

    if (!cartLine.properties.comment) {
        return null;
    }

    return (
        <SmallHeadingAndText
            {...styles.readOnlyCommentText}
            heading={label || translate("Comment")}
            text={cartLine.properties.comment}
        />
    );
};

export default withCartLine(CartLineComment);
